import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "opt-btn"
};
import { Search, Plus } from '@element-plus/icons-vue';
import { onMounted, reactive, ref } from "vue";
import apis from "@/api";
import { ElMessage } from "element-plus";
import Info from './Info.vue';
export default {
  __name: 'Index',
  setup(__props) {
    const infoVisible = ref(false);
    const infoTitle = ref('');
    const infoRef = ref();
    const editFlag = ref(false);
    const activeTab = ref("contract");
    const isAdmin = ref(true);
    const elLoading = ref(false);
    onMounted(() => {
      loadData();
    });
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const data = reactive({
      queryParam: {
        channelCode: '',
        channelName: '',
        contactPhone: ''
      },
      tableData: [],
      pagination: {
        total: 0,
        size: 10,
        current: 1
      }
    });
    const goAdd = () => {
      editFlag.value = true;
      infoTitle.value = '新增渠道信息';
      infoVisible.value = true;
    };
    const goShow = row => {
      editFlag.value = false;
      infoTitle.value = '查看渠道信息';
      infoVisible.value = true;
      infoRef.value.initEdit(row);
    };
    const goEdit = row => {
      editFlag.value = true;
      infoTitle.value = '修改渠道信息';
      infoVisible.value = true;
      infoRef.value.initEdit(row);
    };
    const goDelete = row => {
      ElMessageBox.confirm('确定删除渠道：' + row.channelName, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apis.deleteChannel({
          ids: row.id
        }).then(res => {
          if (res.success) {
            ElMessage.success("删除成功!");
          } else {
            ElMessage.error(res.msg);
          }
        }).catch(err => {
          ElMessage.error(err);
        }).finally(() => {
          loadData();
        });
      });
    };
    const handleSizeChange = val => {
      data.pagination.size = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.current = val;
      loadData();
    };
    const loadData = () => {
      const params = {
        ...data.queryParam,
        ...data.pagination
      };
      elLoading.value = true;
      apis.queryChannelPage(params).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            total,
            size,
            current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_form, {
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "渠道编码"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.queryParam.channelCode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.queryParam.channelCode = $event),
            placeholder: "请输入渠道编码"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "渠道名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.queryParam.channelName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.queryParam.channelName = $event),
            placeholder: "请输入渠道名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "联系人电话"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.queryParam.contactPhone,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.queryParam.contactPhone = $event),
            placeholder: "请输入联系人电话"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Search),
            onClick: loadData,
            plain: ""
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("查询", -1)]))]),
            _: 1
          }, 8, ["icon"]), isAdmin.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            icon: _unref(Plus),
            onClick: goAdd
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("新增", -1)]))]),
            _: 1
          }, 8, ["icon"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: data.tableData,
        style: {
          "width": "100%"
        },
        "header-cell-style": headerStyle.value,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "channelCode",
          label: "渠道编码",
          "min-width": "15%"
        }), _createVNode(_component_el_table_column, {
          prop: "channelName",
          label: "渠道名称",
          "min-width": "40%"
        }), _createVNode(_component_el_table_column, {
          prop: "businessLicense",
          label: "营业执照",
          "min-width": "15%"
        }), _createVNode(_component_el_table_column, {
          prop: "contactName",
          label: "联系人姓名",
          "min-width": "10%"
        }), _createVNode(_component_el_table_column, {
          prop: "contactPhone",
          label: "联系人电话",
          "min-width": "10%"
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          "min-width": "10%"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => goShow(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("查看", -1)]))]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => goEdit(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("修改", -1)]))]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => goDelete(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("删除", -1)]))]),
            _: 1
          }, 8, ["onClick"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "header-cell-style"])), [[_directive_loading, elLoading.value]])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "page-sizes": [10, 20, 50],
        "page-size": data.pagination.size,
        total: data.pagination.total,
        currentPage: data.pagination.current,
        "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => data.pagination.current = $event),
        layout: "total, prev, pager, next, sizes, jumper"
      }, null, 8, ["page-size", "total", "currentPage"])]), _createVNode(Info, {
        ref_key: "infoRef",
        ref: infoRef,
        visible: infoVisible.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = $event => infoVisible.value = $event),
        onSuccess: loadData,
        title: infoTitle.value,
        edit: editFlag.value
      }, null, 8, ["visible", "title", "edit"])]);
    };
  }
};